import { StyleSheet, Text, View } from "react-native"

import { ChartData } from 'chart.js';
import 'chart.js/auto';
import { Doughnut } from "react-chartjs-2";

import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more-dashboard.svg';

import DashboardBox from "../../base/tamplate/DashboardBox"
import { ReactElement } from "react";
import { FONT } from "../../../value/staticValues";


interface DoughnutChartProps {
    navigate?: Function;
    url?: string;
    title: string;
    data: number;
    percent: number;
    total: number;
    chartData: ChartData<'doughnut'>;
    img: ReactElement
    color: string;
    unit: string;   
}

export default function DoughnutChart(props:DoughnutChartProps) {
    const DoughnutChartOption = {
        cutout: '85%',
        plugins: {
            responsive: true,
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false
            }
        }
    }

    return (
        <DashboardBox style={{
            width: 330, height: 320,
            marginRight: 10,
        }}>
            <View style={{alignItems: "center"}}>
                <View style={{flexDirection: "row", alignItems: "center", width: "100%", height: 20}}>
                    <Text style={{
                        fontFamily: FONT.MEDIUM,
                        fontSize: 14,
                        lineHeight: 13,
                        color: "#262626"
                    }}>
                        {props.title}
                    </Text>
                    {props.url && props.navigate?
                        <MoreImg 
                            style={{marginLeft: "auto", cursor: "pointer"}}
                            onClick={() => {if(props.navigate) props.navigate(`${props.url}`);}}
                        />
                    :null }
                </View>
                <View style={{width: 150, height: 150, marginTop: 20}}>
                    <Doughnut data={props.chartData} options={DoughnutChartOption}/>
                </View>
                <View style={{
                    alignItems:"center",
                    position:"absolute", 
                    top: 66, left: 95,
                }}>
                    <View style={styles.ChartCircle}>
                        <View style={{flexDirection: "row", alignItems: "flex-end"}}>
                            <Text style={styles.BigText}>
                                {props.percent}
                            </Text>
                            <Text style={{
                                marginLeft: 3, marginBottom: 5,
                                fontFamily: FONT.BOLD,
                                fontSize: 14,
                                color: "#333"
                            }}>
                                %
                            </Text>
                        </View>
                        <View>
                            <Text style={{
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                color: "#333"
                            }}>
                                USED
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={{
                    marginLeft: "auto", marginTop: -30,
                    // position:"absolute", 
                    // top: 66, left: 95,
                }}>
                    <View style={{flexDirection: "row", alignItems: "center"}}>
                        <View style={{...styles.LegendBox, backgroundColor: props.color}}/>
                        <Text style={styles.LegendText}>
                            Used
                        </Text>
                    </View>
                    <View style={{flexDirection: "row", alignItems: "center"}}>
                        <View style={styles.LegendBox}/>
                        <Text style={styles.LegendText}>
                            Total
                        </Text>
                    </View>
                </View>

                <View style={{borderTopWidth: 1, borderColor: "#e3e1ea", width: 330, marginTop: 20, marginBottom: 20}}/>

                <View style={{flexDirection: "row", width: "100%"}}>
                    <View style={{
                        alignItems: "center", justifyContent: "center",
                        width: 44, height: 44,
                        marginRight: 20,
                        borderRadius: 8,
                        backgroundColor: props.color+"1a"
                    }}>
                        {props.img}
                    </View>
                    <View style={{flexDirection: "row", alignItems: "flex-end"}}>
                        <Text style={styles.BigText}>
                            {props.data}
                        </Text>
                        <Text style={{
                            fontFamily: FONT.REGULAR,
                            fontSize: 10,
                            color: "#808080",
                            marginBottom: 6, marginLeft: 5
                        }}>
                            {props.unit} Used
                        </Text>
                    </View>
                    <View style={{
                        flexDirection: "row", alignItems: "center", justifyContent: "center",
                        minWidth: 80, height: 24,
                        paddingLeft: 10, paddingRight: 10,
                        marginTop: 24, marginLeft: "auto",
                        borderRadius: 18,
                        borderWidth: 1, borderColor: "#e4e1eb",
                    }}>
                        <Text style={{
                            fontFamily: FONT.REGULAR,
                            fontSize: 10,
                            color: "#808080"
                        }}>
                            Total {props.total} {props.unit}
                        </Text>
                    </View>
                </View>
            </View>
        </DashboardBox>
    )
}

const styles = StyleSheet.create({
    ChartCircle: {
        alignItems: "center", justifyContent: "center",
        width: 100, height: 100,
        boxShadow: "0 2px 16px 0 rgba(199, 182, 250, 0.3)",
        borderRadius: 50,
        backgroundColor: "#fff",
    },
    BigText: {
        fontFamily: FONT.BOLD,
        fontSize: 32,
        color: "#333"
    },
    LegendBox: {
        width: 10, height:5,
        marginRight: 5,
        borderRadius: 2.5,
        backgroundColor: "#f5f5f5"
    },
    LegendText: {
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#808080"
    }
})